<template lang="pug">
.modal-go(:class='{ "--loading" : isLoading }')
    .linha
        subtitle-component(
            :label='regiao?.nome'
        )
    //- collapse-component(title='Gerentes disponíveis', :is-basic='true')
    .linha
        b.coluna Gerentes Operacionais
    .linha
        .coluna
            filter-basic-component(
                @filtro:pesquisar='pesquisar($event)',
            )
    .linha
        .coluna
            #go-box(
                :style='[ this.gerentes.length <= 7 ? "" : { columnCount: "2" } ] ',
                :class="[validacao ? '' : '--error' , isLoading ? '--loading' : '']"
            )
                checkbox-group-input-component(
                    v-model='gerentesVinculados',
                    :list='gerentes'
                )
    .linha.acoes(:style="{ marginTop : '40px'}")
        div(style="display: flex; justify-content: space-between; width: 100%")
            button-component(
                label='Cancelar',
                icon='mdi-close',
                backgroundColor='var(--primary-gray)',
                color="var(--primary-light-smoke)"
                @click.native="cancelar()"
            )
            button-component(
                label='Vincular',
                icon='mdi-link-variant',
                :disabled='isLoading',
                @click.native="vincularGo()"
            )

</template>

<script>
import {
    regiaoGerentes,
    vincularGo,
} from '@/services/regiaoAnalise.service';

import FilterBasicComponent from '@/components/standard/FilterBasicComponent.vue';

export default {

    name: 'ModalVincularGo',

    components: {
        FilterBasicComponent
    },

    props: {
        regiaoId: Number,
    },

    data() {
        return {

            gerentesDisponiveis: [],

            gerentesVinculados: [],

            gerentes: [],

            regiao: null,

            isLoading: false,

        }
    },

    async created() {
        this.isLoading = true;
        this.regiao = await this.getRegiaoData(this.regiaoId);
        this.setGerentesDisponiveis();
        this.setGerentesVinculados();
        this.gerentes = [...this.gerentesVinculados, ...this.gerentesDisponiveis];
        // if (this.regiao?.vinculados.length > 0) this.gerentes = [...this.gerentesVinculados, ...this.gerentesDisponiveis];
        // else this.gerentes = [...this.regiao.disponiveis.map(m => { return { ...m, selecionado: false } })];
        this.isLoading = false;
    },

    methods: {

        async vincularGo() {

            if (this.validacao()) {
                let gerentesIds = this.gerentesVinculados.map(g => g.id);
                try {

                    await vincularGo(this.regiaoId, gerentesIds);

                    this.$toast({
                        showClose: true,
                        message: 'Gerentes vinculados com sucesso!!!',
                        type: 'success'
                    });
                    this.$emit('onClose');

                } catch { }
            } else {

                this.$toast({
                    showClose: true,
                    message: 'Dados incorretos!',
                    type: 'error'
                });
            }
        },

        async getRegiaoData(regiaoId) {
            return await regiaoGerentes(regiaoId);
        },

        setGerentesDisponiveis() {
            this.gerentesDisponiveis = this.regiao.disponiveis.map(m => { return { ...m, selecionado: false } });
            this.gerentesDisponiveis.sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
        },

        setGerentesVinculados() {
            if (this.regiao?.vinculados.length > 0) {
                this.gerentesVinculados = this.regiao?.vinculados.map(m => { return { ...m, selecionado: true } })
                this.gerentesVinculados.sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));

            }
        },

        validacao() {
            if (!this.regiao) return false;
            if (this.gerentesVinculados.length < 0) return false;
            return true;
        },

        async pesquisar(searchValue) {
            let prep = [...this.gerentesVinculados, ...this.gerentesDisponiveis];
            let filtered = prep.filter(ger => ger.nome.toLowerCase().includes(searchValue.toLowerCase()));
            this.gerentes = filtered;
        },

        cancelar() {
            this.$emit('cancelar', true);
        }
    }

}
</script>

<style>
.modal-go {
    width: 500px;
    color: var(--primary-black);
}

#go-box {
    height: 250px;
    overflow-y: auto;
}

.regiao {
    margin: 5px 0px 20px 0px;
}

#go-box::-webkit-scrollbar {
    width: 3px;
}

#go-box::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

#go-box::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
}

.modal-go .--loading {
    background-color: var(--primary-smoke);
    background-image: url('../../../assets/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50px 50px;
    content: '';
}
</style>
